// src/api/layout.js
import axios from 'axios';
import config from '../../config/config';
import { token_function } from '../../libs/TokenFile';

// Generic function to fetch layout settings
export const fetchLayoutSettings = async () => {
  const token = token_function();
  const DEFAULT_GLOBAL_CONFIGS = {
    flashbar: {},
    navbar: {},
    banner: {},
    hero: {},
    categoriesnav_2: {},
    categories: {},
    products: {},
    footer: {},
  };

  const freshGlobal = { ...DEFAULT_GLOBAL_CONFIGS };
  //await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, { withCredentials: true }).catch(() => {});

  // fetch main layout + categories nav in parallel
  const [layoutRes] = await Promise.all([
    axios.get(`${config.API_URL}/api/layoutsettings`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    }),
  ]);

const DEFAULT_LAYOUT_ORDER = [
  "flashbar",           // active flashbar with countdown
  "navbar",             // dark-luxury / premium navbar
 // "categoriesnav-2",
 // "banner",             // full-width banner with confetti
  "categories",         // carousel of categories
  "products",           // main products carousel (Discounted Deals Today)
  "hero-2", 
 // "testimonials-2",     // customer testimonials
  "faqs-2",             // FAQ section
  //"christmas-2",
  //"marketingmodals-2",
  //
  "footer"              // comprehensive footer
];
  const layoutData = layoutRes.data ?? {};
  const catNavData = layoutRes.data?.customSettings['categoriesnav-2'] ?? null;

      freshGlobal.flashbar = layoutData?.flashBarSettings ?? freshGlobal.flashbar;
      freshGlobal.navbar = layoutData?.navBarSettings ?? freshGlobal.navbar;
      freshGlobal.banner = layoutData?.bannerSettings ?? freshGlobal.banner;
      freshGlobal.hero = layoutData?.heroSettings ?? freshGlobal.hero;
      freshGlobal.categoriesnav_2 = layoutData?.catSettings ?? freshGlobal.categoriesnav_2;
      freshGlobal.categories = layoutData?.categorySettings ?? freshGlobal.categories;
      freshGlobal.products = layoutData?.productSettings ?? freshGlobal.products;
      freshGlobal.footer = layoutData?.footerSettings ?? freshGlobal.footer;

      const freshOrder = layoutData?.order || DEFAULT_LAYOUT_ORDER;

  return {
    flash: layoutData.flashBarSettings ?? null,
    nav: layoutData.navBarSettings ?? null,
    search: layoutData.searchSettings ?? null,
    cart: layoutData.cartSettings ?? null,
    banner: layoutData.bannerSettings ?? null,
    hero: layoutData.heroSettings ?? null,
    cat: layoutData.catSettings ?? null,
    footer: layoutData.footerSettings ?? null,
     categoriesnav_2:layoutData.catSettings ?? null,
categories:layoutData.categorySettings ?? null,
products:layoutData.productSettings ?? null,
    catNavConfig: catNavData,
    order:layoutData.order,
    customSettings:layoutData.customSettings ?? null,
    freshGlobal:freshGlobal,
    freshOrder:freshOrder,
    
  };
};